import size from "../sizes";
import digitalPrinting from "./templates/digital-printing";
import maintenance from "./templates/maintenance";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Классическая, идеально скроенная рубашка-поло от бельгийской компании Stanley&amp;Stella. Каждая деталь продумана и сделана с умом: фасон, особое плетение ткани «пике», узкий воротник на пуговицах, геометричные вырезы по бокам. Ей не страшны многочисленные стирки, она не выцветает и не теряет формы, и выглядит как новая, даже если носить ее каждый день на работу. Высокая плотность хлопка (200 гр/м<sup>2</sup>) и европейская технология окрашивания гарантируют это. 95% состава ткани — это высококачественный индийский хлопок, оставшиеся 5% — эластан, который придает ткани дополнительную гладкость и мягкость.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати и уход`,
    content: {
      printingInfo: `${digitalPrinting}${maintenance}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`woman_polo`],
      sizeInfo: `woman_polo`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
